const DEFAULT_SUPPORT_EMAIL = 'terafile@digital-ds.com'

export function getSupportEmail(): string {
  return import.meta.env.VITE_SUPPORT_EMAIL ?? DEFAULT_SUPPORT_EMAIL
}

export function getSupportMailto(subject: string, body?: string): string {
  const params = new URLSearchParams({ subject })
  if (body) params.set('body', body)
  return `mailto:${getSupportEmail()}?${params.toString()}`
}
